import { caseTransformingAxios } from "@shared/v2/caseTransformingAxios";
import { AxiosError } from "axios";
import { useState, useEffect } from "react";
import { AccountProduct, Product } from "../../Support/Account/AddOnsSupport/types";
import { transformPlan } from "./useProducts";

const useActiveProducts = (productFamilySlug: string) => {
  const [activeProducts, setActiveProducts] = useState<AccountProduct[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<AxiosError | null>(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    caseTransformingAxios
      .get("/products/active_products", { params: { productFamilySlug } })
      .then((response: { data: AccountProduct[] }) => {
        setActiveProducts(
          response.data.map((accountProduct) => ({
            ...accountProduct,
            product: transformPlan(accountProduct.product as Product),
          })),
        );
        setLoading(false);
      })
      .catch((err) => {
        setError(err as AxiosError);
        setLoading(false);
      });
  }, []);

  return {
    actions: {
      cancelProduct: (
        accountProductId: string | number,
        cancelForm: { status: string; details: { churnCode: string; churnCodeFeedback: string } },
      ) =>
        caseTransformingAxios
          .put(`/products/${accountProductId}`, {
            accountProduct: cancelForm,
          })
          .then(({ data }) => {
            setActiveProducts((prevProducts) =>
              prevProducts.map((product) =>
                product.id === accountProductId ? (data as AccountProduct) : product,
              ),
            );
          })
          .catch((err) => {
            console.log(err);
            throw err;
          }),
    },
    activeProducts,
    loading,
    error,
  };
};

export default useActiveProducts;
